import Layout from "./LoginLayout";

export default Layout;
